module.exports = __webpack_public_path__ + "img/get-linux.805eac87.png";